export const INTERACTIVE_INFOGRAPH_WRAPPER = 'interactive-infograph-wrapper';
export const INTERACTIVE_INFOGRAPH_PAGE = 'interactive-infograph-page';
